import React from 'react';
import Inverite from '../../Inverite';

export default function InveriteServiceProvider(props) {
  return (
    <Inverite
      clientId={props.scoringRequest.clientId}
      requestId={props.scoringRequest.requestId}
      skipBankingSurvey={props.skipBankingSurvey}
      createScoringRequest={props.createScoringRequest}
      onComplete={props.proceedToNext}
      bankId={props.dataProvider.id}
      showBackButton={props.showBackButton}
      webhookData={props.webhookData}
    />
  );
}
